<script>
function recursivelyRemoveFill(el, primary) {
  if (!el) {
    return;
  }
  if (
    el.getAttribute("fill") === "#009688" ||
    el.getAttribute("fill") === "#6c63ff"
  ) {
    el.setAttribute("fill", primary ? primary : "#022534");
  }

  [].forEach.call(el.children, (child) => {
    recursivelyRemoveFill(child, primary);
  });
}
export default {
  name: "SvgImage",
  props: {
    image: {
      type: String,
      default: null,
    },
    hasFill: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    const primary = this.$vuetify.theme.themes.light.primary;

    if (this.$el.firstElementChild.nodeName === "svg") {
      const svgElement = this.$el.firstElementChild;
      recursivelyRemoveFill(svgElement, primary);

      svgElement.setAttribute("height", "100%");
      svgElement.setAttribute("width", `100%`);
      svgElement.classList.add("svg-class");
    }
  },
};
</script>

<template>
  <div
    class="svg-container"
    v-html="require(`!html-loader!../../assets/graphics/${image}.svg`)"
  />
</template>

<style lang="scss" scoped>
.svg-container {
  max-width: 300px;
  margin: 30px auto;
}
.svg-class {
  vertical-align: middle;
}
</style>
